import { useHistory } from "react-router-dom";

import './Header.css';

function Header() {
  const history = useHistory();

  function handleClick() {
    history.replace("/");
  }
  
  return (
    <header className='header'>
      <div className='logo'><img className='clickable' src='/infoway-logo.png' alt='Infoway' onClick={handleClick}/></div>      
      <div className='titlebar'><h2>IUA OAuth2/OIDC Client Simulator</h2></div>
    </header>
  );
}

export default Header;
